import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  brand = environment.brand;

  isFromAcceptInvite = false;

  email: string;
  password: string;
  twoFactorToken: string;

  isLoading: boolean;
  error: any;

  passwordRevealed = false;

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) {}

  public ngOnInit(): void {
    this.isFromAcceptInvite = this.route.snapshot.queryParamMap.get('from') === 'accept-invite';
    if (this.isFromAcceptInvite) {
      this.email = this.route.snapshot.queryParamMap.get('email') ?? '';
    } else {
      if (this.authService.isLoggedIn()) {
        this.router.navigate(['admin']);
      }
    }
  }

  public async login() {
    if (this.isLoading) return;

    try {
      this.error = null;
      this.isLoading = true;
      await this.authService.login(this.email, this.password, this.twoFactorToken ?? '');
      if (!this.authService.user.twoFactorSecret) {
        this.router.navigate(['admin', 'two-factor-setup']).then();
      } else {
        const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/admin';
        this.router.navigate([returnUrl]).then();
      }
    } catch (error) {
      this.error = error;
    } finally {
      this.isLoading = false;
    }
  }
}
